
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"15","width":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.427.508l.079.07 5.833 5.833.014.014c.019.02.037.04.054.062l-.068-.076a.84.84 0 01.244.589v.046a.838.838 0 01-.003.033L19.583 7a.83.83 0 01-.174.51l-.013.017a.838.838 0 01-.046.052l-.01.01-5.834 5.834a.833.833 0 01-1.248-1.1l.07-.079 4.409-4.41H1.297a.833.833 0 01-.096-1.662l.097-.005h15.44l-4.41-4.411a.833.833 0 01-.07-1.1l.07-.079c.3-.3.773-.323 1.1-.069z"}})])
          )
        }
      }
    